import { lazy, Suspense, type FC } from "react";

import * as A from "../ui/avatar";

import { isValidImageSrc } from "@/utils/content/imageHelper";

const ImagePreviewer = lazy(() =>
  import("@/components/imagePreview/ImagePreviewer").then((module) => ({
    default: module.ImagePreviewer,
  })),
);

type AvatarProps = {
  src?: string;
  name: string;
  bg?: "none" | string;
  size?: string | number;
  className?: string;
  showHoverContent?: boolean;
  titleName?: string;
};

const Avatar: FC<AvatarProps> = ({
  bg,
  name,
  src,
  size,
  className,
  showHoverContent,
  titleName,
}) => {
  const trigger = (
    <A.SAvatar
      bg={bg}
      name={name}
      src={src}
      size={size}
      className={className}
      titleName={titleName}
    />
  );

  // Sometimes, the backend sends image src as 'null', which causes the image previewer to break. This check ensures that the previewer only attempts to load valid image URLs.
  if (!isValidImageSrc(src)) {
    return trigger;
  }

  return (
    <Suspense fallback={trigger}>
      <ImagePreviewer
        imagesSrc={src!}
        showHoverContent={showHoverContent}
        alt={`${name || "User"}'s Avatar`}
        trigger={trigger}
      />
    </Suspense>
  );
};

export default Avatar;
